// This is NOT auto-type

// One title / message pair per language (e.g. "de-CH", "fr-FR", "en-GB", "it-CH").
export class MessageTranslationTextDto {
	public languageCode: string = "";
	public titel: string = "";
	public message: string = "";
}

export class MessageTranslationDto {
	public id: number = 0;
	public boostKey: string = "";
	public errorCode: string = "";
	public messageType: number = 0;
	// Deprecated: German (de-CH) fallback. Use `texts` for the per-language content.
	public newMessageTitle: string = "";
	// Deprecated: German (de-CH) fallback. Use `texts` for the per-language content.
	public newMessage: string = "";
	public newSeverity: number = 0;
	public ignore: boolean = false;
	public ignoreFirstTime: boolean = false;
	public helpLink: string = "";
	public texts: MessageTranslationTextDto[] = [];
}
